
import React, { useState, useEffect } from 'react';
import { getStudioApiKey } from '../utils/audio';

interface SafeHarborProps {
  ui: any;
}

const SafeHarbor: React.FC<SafeHarborProps> = ({ ui }) => {
  const t = ui.safe;
  const [locationInfo, setLocationInfo] = useState<{ country?: string; city?: string }>({});
  const hasKey = !!getStudioApiKey();

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        try {
          const res = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=en`);
          const data = await res.json();
          setLocationInfo({ country: data.countryName, city: data.city });
        } catch (e) { console.error("Geo lookup failed"); }
      });
    }
  }, []);

  const HELPLINES = [
    { country: 'Australia', name: 'Lifeline', number: '13 11 14', url: 'https://www.lifeline.org.au' },
    { country: 'USA', name: '988 Suicide & Crisis Lifeline', number: '988', url: 'https://988lifeline.org' },
    { country: 'United Kingdom', name: 'Samaritans', number: '116 123', url: 'https://www.samaritans.org' }
  ];

  return (
    <div className="h-full space-y-12 max-w-5xl mx-auto animate-in fade-in slide-in-from-bottom-6 duration-700 pb-20">
      <div className="text-center space-y-6 text-left">
        <h2 className="text-6xl font-black text-white tracking-tighter leading-tight uppercase">{t.title}</h2>
        <p className="text-xl text-gray-400 font-light max-w-2xl mx-auto leading-relaxed">{t.subtitle}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
        <div className="p-10 rounded-[3rem] bg-black/40 border border-white/10 backdrop-blur-xl space-y-8 flex flex-col justify-between">
           <div>
              <p className="text-[10px] font-black text-gray-500 uppercase tracking-widest mb-4">{t.location_label}</p>
              <h3 className="text-4xl font-black text-white">{locationInfo.city || 'Scanning...'}, {locationInfo.country || 'Global'}</h3>
           </div>
           
           <div className={`px-6 py-4 rounded-2xl text-[10px] font-black uppercase tracking-[0.2em] border flex items-center justify-between ${hasKey ? 'bg-green-500/10 text-green-500 border-green-500/30' : 'bg-red-500/10 text-red-500 border-red-500/30'}`}>
              <span>Protocol Handshake: {hasKey ? 'Authorized' : 'Missing'}</span>
              <i className={`fa-solid ${hasKey ? 'fa-link' : 'fa-link-slash'}`}></i>
           </div>

           <div className="pt-6 border-t border-white/5">
              <p className="text-[9px] font-black text-groove-accent uppercase tracking-widest mb-2">{t.emergency_label}</p>
              <p className="text-3xl font-black text-white">000 / 911 / 999</p>
           </div>
        </div>

        <div className="p-10 rounded-[3rem] bg-black/40 border border-white/10 backdrop-blur-xl space-y-6 overflow-y-auto max-h-[500px] custom-scrollbar">
           <p className="text-[10px] font-black text-gray-500 uppercase tracking-widest mb-4">{t.directory_label}</p>
           {HELPLINES.map((line, i) => (
             <div key={i} className="p-6 rounded-2xl border border-white/5 bg-white/5">
                <h4 className="text-lg font-black text-white mb-2">{line.name}</h4>
                <a href={`tel:${line.number}`} className="text-2xl font-black text-groove-accent hover:underline">{line.number}</a>
             </div>
           ))}
        </div>
      </div>
    </div>
  );
};

export default SafeHarbor;
